import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';

import { BackLink } from 'enrollment/components';
import { InternalPage } from 'theSource/components';
import { ROUTES } from 'theSource/app/routes';
import {
  PageWrapperStyled,
  CardContentStyled,
  CardStyled,
  TitleLabelStyled,
} from './TermsStyled';
import { termsOfUse } from 'theSource/assets';

export const TermsDisplay = () => {
  // const { t } = useTranslation('pages.termsofuse');
  const { t } = useTranslation(['pages.termsofuse', 'pages.legalDocuments']);

  const pageData = termsOfUse.content;
  const pageTitle = t('title');
  const termsAndConditionsLabel = t(
    'pages.legalDocuments:termsAndConditionsLabel'
  );

  return (
    <>
      <BackLink
        underline={false}
        testId="back-button"
        className="mb-4"
        defaultPath={`${ROUTES.public.legalDocuments.path}/`}
      />
      <InternalPage
        testId="terms-and-conditions-page"
        title={termsAndConditionsLabel}
      >
        <PageWrapperStyled data-testid="terms-of-use-read-only">
          <CardStyled>
            <CardContentStyled>
              <TitleLabelStyled className="headline-3">
                {pageTitle}
              </TitleLabelStyled>
              <Typography
                variant="body2"
                dangerouslySetInnerHTML={{ __html: pageData }}
              />
            </CardContentStyled>
          </CardStyled>
        </PageWrapperStyled>
      </InternalPage>
    </>
  );
};
